import { useId } from 'react';
import './SafeLinkGuardIcon.css';

type SafeLinkGuardIconProps = {
    variant?: 'lite' | 'pro';
    size?: number;
    color?: string;
    className?: string;
    title?: string;
};

const SHIELD_PATH = 'M12 2.25 L4.5 4.25 C3.95 4.4 3.5 4.95 3.5 5.55 V12.5 C3.5 16.5 7.4 19.85 12 21.5 C16.6 19.85 20.5 16.5 20.5 12.5 V5.55 C20.5 4.95 20.05 4.4 19.5 4.25 Z';

const LINK_LEFT_PATH = 'M10.4 8.6 C8.85 8.6 7.6 9.85 7.6 11.4 C7.6 12.95 8.85 14.2 10.4 14.2 L11.7 14.2';
const LINK_RIGHT_PATH = 'M13.6 14.2 C15.15 14.2 16.4 12.95 16.4 11.4 C16.4 9.85 15.15 8.6 13.6 8.6 L12.3 8.6';
const LINK_CONNECTOR_PATH = 'M9.6 11.4 L14.4 11.4';

const SafeLinkGuardIcon = ({
    variant = 'lite',
    size = 16,
    color = 'currentColor',
    className,
    title,
}: SafeLinkGuardIconProps) => {
    const isPro = variant === 'pro';
    const reactId = useId();
    const maskId = `slg-mask-${reactId.replace(/[^a-zA-Z0-9]/g, '')}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={1.6}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`safe-link-guard-icon safe-link-guard-icon--${variant}${className ? ' ' + className : ''}`}
            aria-hidden={title ? undefined : true}
            role={title ? 'img' : undefined}
        >
            {title && <title>{title}</title>}

            {isPro ? (
                <>
                    <defs>
                        <mask id={maskId}>
                            <rect x="0" y="0" width="24" height="24" fill="white" />
                            <g transform="translate(12 11.4) scale(1.30) translate(-12 -11.4)">
                                <path d={LINK_LEFT_PATH} stroke="black" strokeWidth={1.5} fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                <path d={LINK_RIGHT_PATH} stroke="black" strokeWidth={1.5} fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                <path d={LINK_CONNECTOR_PATH} stroke="black" strokeWidth={1.6} fill="none" strokeLinecap="round" />
                            </g>
                        </mask>
                    </defs>
                    <path d={SHIELD_PATH} fill={color} stroke="none" mask={`url(#${maskId})`} />
                </>
            ) : (
                <>
                    <path d={SHIELD_PATH} fill="none" />
                    <path d={LINK_LEFT_PATH} fill="none" />
                    <path d={LINK_RIGHT_PATH} fill="none" />
                    <path d={LINK_CONNECTOR_PATH} fill="none" />
                </>
            )}
        </svg>
    );
};

export default SafeLinkGuardIcon;
